import { EcoaInput } from "@components/common/EcoaInput";
import { useCallback, useEffect, useState } from "react";
import { useCaptureContext } from "@layouts/ecoa/CaptureContext";
import { VisitQuestionnaireAnswer } from "@pages/ecoa/visit/VisitQuestionnaire";
import { CrfAutoTextItemSpec, InitialItemSequence } from "maven-lib/dist/consts/edc";
import { StudyCaptureDBVal } from "maven-lib/dist/consts/edc/capture";
import { edcDateFormat, getCalcVal } from "maven-lib/dist/consts/edc/lib";
import { StudyCapture } from "maven-lib/dist/dto/entity";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";

interface QuestionnaireAutoTextItemProps {
  questionnaire: EcoaQuestionnaire;
  item: CrfAutoTextItemSpec;
  folderId?: string;
  visitId?: string;
  visitSeq?: number;
  crfPageId?: string;
  crfPageSeq?: number;
  disabled?: boolean;
  isAvailable?: boolean;
  defaultItemValues?: Array<{ itemId: string | null; dbVal: string | number | null }>;
  onValueChange: (values: Array<VisitQuestionnaireAnswer>) => void;
}

export function QuestionnaireAutoTextItem({
  item,
  defaultItemValues,
  folderId,
  visitId,
  visitSeq,
  crfPageId,
  crfPageSeq,
  onValueChange,
}: QuestionnaireAutoTextItemProps) {
  const { uiPrefix, uiSuffix } = item;
  const { captures } = useCaptureContext();
  const [dbVal, setDbval] = useState(defaultItemValues?.find((val) => val.itemId === item.id)?.dbVal || null);
  const [value, setValue] = useState<string>();

  const formattedItem = useCallback(
    (dbVal: StudyCaptureDBVal) => {
      if (typeof dbVal === "number") return `${dbVal}`;
      else if (!dbVal) return "";
      else if (
        item.format === "YYYY/MM/DD" ||
        item.format === "YYYY-MM-DD" ||
        item.format === "DD-MMM-YYYY" ||
        item.format === "DD/MMM/YYYY" ||
        item.format === "YYYY/MM" ||
        item.format === "YYYY-MM" ||
        item.format === "YYYY" ||
        item.format === "MMM/YYYY"
      ) {
        return edcDateFormat(dbVal, item.format);
      } else {
        return dbVal;
      }
    },
    [item.format]
  );

  useEffect(() => {
    if (item.calculate && folderId && visitId && visitSeq && crfPageId && crfPageSeq) {
      const dbVal = getCalcVal(
        item.calculate,
        {
          folderId: folderId,
          visitId: visitId,
          visitSeq: visitSeq,
          crfPageId: crfPageId,
          crfPageSeq: crfPageSeq,
          itemSeq: InitialItemSequence,
        },
        captures as StudyCapture[]
      );

      setDbval(dbVal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captures]);

  useEffect(() => {
    onValueChange([{ itemId: item.id, dbVal: dbVal, calcVal: undefined }]);
    setValue(formattedItem(dbVal));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbVal]);

  return (
    <EcoaInput
      disabled={true}
      placeholder={item.placeholder}
      onValueChange={() => {}}
      defaultVal={value}
      prefix={typeof uiPrefix === "string" ? uiPrefix : undefined} // NOTE: 20231013 prefix에서 site code나 item ref 조건은 필요한 경우 구현하기로 함
      suffix={typeof uiSuffix === "string" ? uiSuffix : undefined}
    />
  );
}
